/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { ControllerResponse__deleted_number__ } from '../models/ControllerResponse__deleted_number__';
import type { ControllerResponse_PipelineHealthOrganizationBuildingScrape_Array_ } from '../models/ControllerResponse_PipelineHealthOrganizationBuildingScrape_Array_';
import type { ControllerResponse_PipelineHealthOrganizationBuildingTrends_ } from '../models/ControllerResponse_PipelineHealthOrganizationBuildingTrends_';
import type { ControllerResponse_PipelineHealthStatistic_Array_ } from '../models/ControllerResponse_PipelineHealthStatistic_Array_';
import type { CancelablePromise } from '../core/CancelablePromise';
import type { BaseHttpRequest } from '../core/BaseHttpRequest';
export class PipelineHealthService {
    constructor(public readonly httpRequest: BaseHttpRequest) {}
    /**
     * @param fromDate Inclusive start date (YYYY-MM-DD). Required if to_date is set.
     * @param toDate Inclusive end date (YYYY-MM-DD). Required if from_date is set.
     * @returns ControllerResponse_PipelineHealthStatistic_Array_ Ok
     * @throws ApiError
     */
    public list(
        fromDate?: string,
        toDate?: string,
    ): CancelablePromise<ControllerResponse_PipelineHealthStatistic_Array_> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/pipeline_health',
            query: {
                'from_date': fromDate,
                'to_date': toDate,
            },
        });
    }
    /**
     * @param scrapedDate Calendar date of organization building scrapes (YYYY-MM-DD).
     * @returns ControllerResponse_PipelineHealthOrganizationBuildingScrape_Array_ Ok
     * @throws ApiError
     */
    public listOrganizationBuildings(
        scrapedDate: string,
    ): CancelablePromise<ControllerResponse_PipelineHealthOrganizationBuildingScrape_Array_> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/pipeline_health/organization_buildings',
            query: {
                'scraped_date': scrapedDate,
            },
        });
    }
    /**
     * @param selectedDate Inclusive end date (YYYY-MM-DD). Returns that day plus the previous 30 days.
     * @returns ControllerResponse_PipelineHealthOrganizationBuildingTrends_ Ok
     * @throws ApiError
     */
    public listOrganizationBuildingsTrends(
        selectedDate: string,
    ): CancelablePromise<ControllerResponse_PipelineHealthOrganizationBuildingTrends_> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/pipeline_health/organization_buildings/trends',
            query: {
                'selected_date': selectedDate,
            },
        });
    }
    /**
     * @returns ControllerResponse__deleted_number__ Ok
     * @throws ApiError
     */
    public invalidateCache(): CancelablePromise<ControllerResponse__deleted_number__> {
        return this.httpRequest.request({
            method: 'DELETE',
            url: '/pipeline_health/cache',
        });
    }
}
